import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Query } from 'react-apollo'
import accounting from 'accounting'
import moment from 'moment'

// graphql queries
import coupons from 'graphql/queries/coupons'

// material-ui-icons
import AssignmentInd from 'material-ui-icons/AssignmentInd'
import AssignmentLate from 'material-ui-icons/AssignmentLate'
import Assignment from 'material-ui-icons/Assignment'
import AssignmentTurnedIn from 'material-ui-icons/AssignmentTurnedIn'
import AssignmentReturnedIcon from 'material-ui-icons/AssignmentReturned'
import Style from 'material-ui-icons/Style'
import Search from 'material-ui-icons/Search'
import Add from 'material-ui-icons/Add'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'
import Button from 'material-ui/Button'
import Table from 'material-ui/Table'
import TableHead from 'material-ui/Table/TableHead'
import TableCell from 'material-ui/Table/TableCell'
import TableBody from 'material-ui/Table/TableBody'
import TableRow from 'material-ui/Table/TableRow'
import TextField from 'material-ui/TextField'
import InputAdornment from 'material-ui/Input/InputAdornment'
import FormControlLabel from 'material-ui/Form/FormControlLabel'
import Checkbox from 'material-ui/Checkbox'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'
import StatsCard from 'components/Cards/StatsCard.jsx'
import IconCard from 'components/Cards/IconCard.jsx'
import CouponModalForm from 'components/CouponModalForm/CouponModalForm.jsx'

import tableStyle from 'assets/jss/material-dashboard-pro-react/components/tableStyle.jsx'

const FiltroCoupon = (props) => {
  return (
    <div style={{ margin: '0 60px 20px 0' }}>
      <TextField
        label="Cerca..."
        id="cerca"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search />
            </InputAdornment>
          ),
          value: props.value,
          onChange: props.onChange,
        }}
      />
    </div>
  )
}

const price = (amount) => {
  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      {accounting.formatMoney(amount, '€ ', 0, '.', ',')}
    </span>
  )
}

class Coupon extends Component {
  constructor(props) {
    super(props)

    this.state = {
      keyword: '',
      hideDisattivati: false,
      showModal: false,
      initialValues: {},
      isNewCoupon: true,
    }
  }

  handleSearch = (event) => {
    this.setState({
      keyword: event.target.value,
    })
  }

  handleHideDisattivatiCheckbox = (event) => {
    this.setState({
      hideDisattivati: event.target.checked,
    })
  }

  closeModal = () => {
    this.setState({
      showModal: false,
      initialValues: {},
    })
  }

  handleOpenEditCouponModal = (coupon) => (event) => {
    event.preventDefault()
    this.setState({
      showModal: true,
      isNewCoupon: false,
      initialValues: {
        ...coupon,
        dataLimiteAssegnazione: moment(coupon.dataLimiteAssegnazione).format('DD/MM/YYYY'),
        dataLimiteAttivazione: moment(coupon.dataLimiteAttivazione).format('DD/MM/YYYY'),
        dataLimiteUtilizzo: moment(coupon.dataLimiteUtilizzo).format('DD/MM/YYYY'),
      },
    })
  }

  handleOpenCreateCouponModal = () => {
    this.setState({
      showModal: true,
      isNewCoupon: true,
      initialValues: {
        ...this.state.initialValues,
        stato: 'DA_ASSEGNARE',
        // dataLimiteAssegnazione: moment().add(1, 'month').format('DD/MM/YYYY'),
        // dataLimiteAttivazione: moment().add(2, 'month').format('DD/MM/YYYY'),
        // dataLimiteUtilizzo: moment().add(3, 'month').format('DD/MM/YYYY'),
        dataLimiteAssegnazione: '31/03/2022',
        dataLimiteAttivazione: '31/03/2022',
        dataLimiteUtilizzo: '31/03/2022',
      },
    })
  }

  renderStatus = (stato) => {
    switch (stato) {
      case 'DA_ASSEGNARE':
        return (
          <div
            style={{
              backgroundColor: '#ffa726',
              color: '#fff',
              fontSize: '12px',
              fontWeight: 'bold',
              padding: '3px 6px',
              textAlign: 'center',
              borderRadius: 4,
            }}
          >
            DA ASSEGNARE
          </div>
        )
      case 'DA_ATTIVARE':
        return (
          <div
            style={{
              backgroundColor: '#26c6da',
              color: '#fff',
              fontSize: '12px',
              fontWeight: 'bold',
              padding: '3px 6px',
              textAlign: 'center',
              borderRadius: 4,
            }}
          >
            DA ATTIVARE
          </div>
        )
      case 'ATTIVATO':
        return (
          <div
            style={{
              backgroundColor: '#66bb6a',
              color: '#fff',
              fontSize: '12px',
              fontWeight: 'bold',
              padding: '3px 6px',
              textAlign: 'center',
              borderRadius: 4,
            }}
          >
            ATTIVATO
          </div>
        )
      case 'PROPOSTA':
        return (
          <div
            style={{
              backgroundColor: '#9c27b0',
              color: '#fff',
              fontSize: '12px',
              fontWeight: 'bold',
              padding: '3px 6px',
              textAlign: 'center',
              borderRadius: 4,
            }}
          >
            PROPOSTA
          </div>
        )
      case 'UTILIZZATO':
        return (
          <div
            style={{
              backgroundColor: '#cccccc',
              color: '#fff',
              fontSize: '12px',
              fontWeight: 'bold',
              padding: '3px 6px',
              textAlign: 'center',
              borderRadius: 4,
            }}
          >
            UTILIZZATO
          </div>
        )
      case 'DISATTIVATO':
        return (
          <div
            style={{
              backgroundColor: '#cccccc',
              color: '#fff',
              fontSize: '12px',
              fontWeight: 'bold',
              padding: '3px 6px',
              textAlign: 'center',
              borderRadius: 4,
            }}
          >
            DISATTIVATO
          </div>
        )
      default:
        return null
    }
  }

  render() {
    const numeroCouponDaAssegnare = (coupons) =>
      coupons.reduce((acc, coupon) => {
        return acc + (coupon.stato === 'DA_ASSEGNARE' ? 1 : 0)
      }, 0)
    const numeroCouponDaAttivare = (coupons) =>
      coupons.reduce((acc, coupon) => {
        return acc + (coupon.stato === 'DA_ATTIVARE' ? 1 : 0)
      }, 0)
    const numeroCouponAttivati = (coupons) =>
      coupons.reduce((acc, coupon) => {
        return acc + (coupon.stato === 'ATTIVATO' ? 1 : 0)
      }, 0)
    const numeroCouponProposta = (coupons) =>
      coupons.reduce((acc, coupon) => {
        return acc + (coupon.stato === 'PROPOSTA' ? 1 : 0)
      }, 0)
    const numeroCouponUtilizzati = (coupons) =>
      coupons.reduce((acc, coupon) => {
        return acc + (coupon.stato === 'UTILIZZATO' ? 1 : 0)
      }, 0)

    const importoCouponDaAssegnare = (coupons) =>
      coupons.reduce((acc, coupon) => {
        return acc + (coupon.stato === 'DA_ASSEGNARE' ? coupon.importo : 0)
      }, 0)
    const importoCouponDaAttivare = (coupons) =>
      coupons.reduce((acc, coupon) => {
        return acc + (coupon.stato === 'DA_ATTIVARE' ? coupon.importo : 0)
      }, 0)
    const importoCouponAttivati = (coupons) =>
      coupons.reduce((acc, coupon) => {
        return acc + (coupon.stato === 'ATTIVATO' ? coupon.importo : 0)
      }, 0)
    const importoCouponProposta = (coupons) =>
      coupons.reduce((acc, coupon) => {
        return acc + (coupon.stato === 'PROPOSTA' ? coupon.importo : 0)
      }, 0)
    const importoCouponUtilizzati = (coupons) =>
      coupons.reduce((acc, coupon) => {
        return acc + (coupon.stato === 'UTILIZZATO' ? coupon.importo : 0)
      }, 0)

    const isScadutoDaAssegnare = (coupon) => {
      return (
        coupon.stato === 'DA_ASSEGNARE' &&
        moment(coupon.dataLimiteAssegnazione, 'YYYY-MM-DD HH:mm', true).isBefore(moment())
      )
    }
    const isScadutoDaAttivare = (coupon) => {
      return (
        coupon.stato === 'DA_ATTIVARE' &&
        moment(coupon.dataLimiteAttivazione, 'YYYY-MM-DD HH:mm', true).isBefore(moment())
      )
    }
    const isScadutoAttivato = (coupon) => {
      return (
        coupon.stato === 'ATTIVATO' &&
        moment(coupon.dataLimiteUtilizzo, 'YYYY-MM-DD HH:mm', true).isBefore(moment())
      )
    }
    const isScaduto = (coupon) => {
      return (
        isScadutoDaAssegnare(coupon) || isScadutoDaAttivare(coupon) || isScadutoAttivato(coupon)
      )
    }

    const filteredCoupons = (coupons) => {
      return coupons.filter((coupon) => {
        return (
          ((coupon.cliente &&
            coupon.cliente.nome.toLowerCase().indexOf(this.state.keyword.toLowerCase()) > -1) ||
            coupon.codice.toLowerCase().indexOf(this.state.keyword.toLowerCase()) > -1) &&
            (!!this.state.hideDisattivati ? coupon.stato !== 'DISATTIVATO' : true)
            // (!!this.state.hideDisattivati ? !isScaduto(coupon) : true)
        )
      })
    }

    const { classes } = this.props

    return (
      <div className="coupon">
        <Query
          query={coupons}
          variables={{
            limit: 20000,
          }}
          fetchPolicy="cache-and-network"
        >
          {({ loading, error, data }) => {
            if (loading) return <p>Loading...</p>
            if (error) return <p>Error :(</p>

            const COUPONS = data.coupons.nodes
            const tipologie = COUPONS.reduce((acc, coupon) => {
              if (!acc.find((t) => t === coupon.tipologia)) {
                acc.push(coupon.tipologia)
                return acc
              }
              return acc
            }, [])

            return (
              <React.Fragment>
                <GridContainer>
                  <ItemGrid xs={12} sm={6} md={6} lg={4}>
                    <StatsCard
                      icon={Assignment}
                      iconColor="orange"
                      title="Da assegnare"
                      description={price(importoCouponDaAssegnare(COUPONS))}
                      statIcon={Style}
                      statText={`${numeroCouponDaAssegnare(COUPONS)} coupon`}
                    />
                  </ItemGrid>
                  <ItemGrid xs={12} sm={6} md={6} lg={4}>
                    <StatsCard
                      icon={AssignmentInd}
                      iconColor="blue"
                      title="Da attivare"
                      description={price(importoCouponDaAttivare(COUPONS))}
                      statIcon={Style}
                      statText={`${numeroCouponDaAttivare(COUPONS)} coupon`}
                    />
                  </ItemGrid>
                  <ItemGrid xs={12} sm={6} md={6} lg={4}>
                    <StatsCard
                      icon={AssignmentLate}
                      iconColor="green"
                      title="Attivati"
                      description={price(importoCouponAttivati(COUPONS))}
                      statIcon={Style}
                      statText={`${numeroCouponAttivati(COUPONS)} coupon`}
                    />
                  </ItemGrid>
                  <ItemGrid xs={12} sm={6} md={6} lg={4}>
                    <StatsCard
                      icon={AssignmentReturnedIcon}
                      iconColor="purple"
                      title="Proposta"
                      description={price(importoCouponProposta(COUPONS))}
                      statIcon={Style}
                      statText={`${numeroCouponProposta(COUPONS)} coupon`}
                    />
                  </ItemGrid>
                  <ItemGrid xs={12} sm={6} md={6} lg={4}>
                    <StatsCard
                      icon={AssignmentTurnedIn}
                      iconColor="gray"
                      title="Utilizzati"
                      description={price(importoCouponUtilizzati(COUPONS))}
                      statIcon={Style}
                      statText={`${numeroCouponUtilizzati(COUPONS)} coupon`}
                    />
                  </ItemGrid>
                </GridContainer>

                <GridContainer>
                  <ItemGrid xs={12}>
                    <IconCard
                      icon={Style}
                      iconColor="purple"
                      title="Coupon"
                      content={
                        <div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <div style={{ display: 'flex' }}>
                              <FiltroCoupon
                                value={this.state.keyword}
                                onChange={this.handleSearch}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={this.state.hideDisattivati}
                                    onChange={this.handleHideDisattivatiCheckbox}
                                    value="onlyNonScaduti"
                                    color="primary"
                                  />
                                }
                                label="Nascondi disattivati"
                              />
                            </div>
                            <div>
                              <Button
                                variant="raised"
                                color="primary"
                                onClick={this.handleOpenCreateCouponModal}
                                style={{ margin: '20px 40px 20px 0' }}
                              >
                                <Add /> Aggiungi coupon
                              </Button>
                            </div>
                          </div>
                          <Table className={classes.table}>
                            <TableHead>
                              <TableRow>
                                <TableCell className={classes.tableHeadCell}>Codice</TableCell>
                                <TableCell className={classes.tableHeadCell}>Tipologia</TableCell>
                                <TableCell className={classes.tableHeadCell}>Cliente</TableCell>
                                <TableCell className={classes.tableHeadCell}>Importo</TableCell>
                                <TableCell className={classes.tableHeadCell}>Stato</TableCell>
                                <TableCell className={classes.tableHeadCell}>Creato il</TableCell>
                                <TableCell className={classes.tableHeadCell}>
                                  Assegnare entro il
                                </TableCell>
                                <TableCell className={classes.tableHeadCell}>
                                  Attivare entro il
                                </TableCell>
                                <TableCell className={classes.tableHeadCell}>
                                  Utilizzare entro il
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {filteredCoupons(COUPONS).map((coupon) => (
                                <TableRow
                                  key={coupon.id}
                                  style={{
                                    backgroundColor: isScaduto(coupon) ? '#ececec' : '#ffffff',
                                  }}
                                >
                                  <TableCell className={classes.tableCell} style={{ fontSize: 18 }}>
                                    <a href="#" onClick={this.handleOpenEditCouponModal(coupon)}>
                                      {coupon.codice}
                                    </a>
                                  </TableCell>
                                  <TableCell className={classes.tableCell}>
                                    {coupon.tipologia}
                                  </TableCell>
                                  <TableCell className={classes.tableCell}>
                                    {coupon.clienteId ? (
                                      <Link to={`/clienti/${coupon.clienteId}`}>
                                        {coupon.cliente.nome}
                                      </Link>
                                    ) : null}
                                  </TableCell>
                                  <TableCell className={classes.tableCell}>
                                    {price(coupon.importo)}
                                  </TableCell>
                                  <TableCell className={classes.tableCell}>
                                    {this.renderStatus(coupon.stato)}
                                  </TableCell>
                                  <TableCell className={classes.tableCell}>
                                    {coupon.dataCreazione
                                      ? moment(coupon.dataCreazione).format('DD/MM/YYYY')
                                      : ''}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableCell}
                                    style={{
                                      color: isScadutoDaAssegnare(coupon) ? '#ef5350' : '#212121',
                                      fontWeight: isScadutoDaAssegnare(coupon) ? '600' : '300',
                                    }}
                                  >
                                    {coupon.dataLimiteAssegnazione
                                      ? moment(coupon.dataLimiteAssegnazione).format('DD/MM/YYYY')
                                      : ''}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableCell}
                                    style={{
                                      color: isScadutoDaAttivare(coupon) ? '#ef5350' : '#212121',
                                      fontWeight: isScadutoDaAttivare(coupon) ? '600' : '300',
                                    }}
                                  >
                                    {coupon.dataLimiteAttivazione
                                      ? moment(coupon.dataLimiteAttivazione).format('DD/MM/YYYY')
                                      : ''}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableCell}
                                    style={{
                                      color: isScadutoAttivato(coupon) ? '#ef5350' : '#212121',
                                      fontWeight: isScadutoAttivato(coupon) ? '600' : '300',
                                    }}
                                  >
                                    {coupon.dataLimiteUtilizzo
                                      ? moment(coupon.dataLimiteUtilizzo).format('DD/MM/YYYY')
                                      : ''}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </div>
                      }
                    ></IconCard>
                  </ItemGrid>
                </GridContainer>

                <CouponModalForm
                  initialValues={this.state.initialValues}
                  isNewCoupon={this.state.isNewCoupon}
                  tipologie={tipologie}
                  open={!!this.state.showModal}
                  onCloseModal={this.closeModal}
                />
              </React.Fragment>
            )
          }}
        </Query>
      </div>
    )
  }
}

export default withStyles(tableStyle)(Coupon)



// WEBPACK FOOTER //
// ./src/views/App/Coupon/Coupon.jsx